module.exports = __webpack_public_path__ + "img/pc-switch-version.ecc67088.png";